// Patch for issue QS-1632, can be removed once the ticket is merged in to QT
function fixSettingsForSlider( settings, target ) {
	if ( ! target.classList.contains( 'product-image-slider' ) ) {
		return settings;
	}

	const carousel = document.querySelector( '.product-image-slider' );

	// Set default settings
	let sliderLoop = false;
	let sliderObserver = false;

	const slidesShown = parseInt( carousel?.dataset?.sliderType );

	// If slider is set to show more then 1 image, we need to enable loop and observer
	if ( ! Number.isNaN( slidesShown ) && slidesShown > 1 ) {
		sliderLoop = true;
		sliderObserver = true;
	}

	settings.loop = sliderLoop;
	settings.observer = sliderObserver;

	return settings;
}

const singleProductPageCheck = document.querySelector( '.single-product' );
if ( singleProductPageCheck ) {
	wp.hooks.addFilter( 'qala_theme.filter.slider_settings', 'biabed_qs_1632', fixSettingsForSlider, 10 );
}
